import {
  B000111ChohyoBunruiNm1,
  B000111ChohyoBunruiNm2,
  B000111ChohyoBunruiNm3,
  B000111ChohyoBunruiNm4,
  B000111ChohyoBunruiNm5,
  B000111ChohyoBunruiNm6,
  B000111ChohyoBunruiNm7,
  B000111ChohyoBunruiNm8,
  B000111ChohyoBunruiNm9,
  B000111ChohyoBunruiNm10,
  B000111ChohyoBunruiNm11,
  B000111ChohyoBunruiNm12,
  B000111ChohyoBunruiNm13,
  B000111ChohyoBunruiNm14,
  B000111ChohyoBunruiNm15,
  B000111KakoshubetsuNm,
  B000111ShobumNm1,
  B000111ShobumNm2,
  B000111ShobumNm3,
  B000111ShobumNm4,
  B000111ShobumNm5,
  catchRestError,
  RestClient,
  B000111SakaNm,
  B000200ZairyoshohinNm,
  B000111WhtankaNm,
  B000111WhgentankaNm,
  B000202ShodaibunruiNm,
  B000202ShochubunruiNm,
  B000202ShoshobunruiNm,
  B000170ShireNmr,
} from "clients/rest";
import {
  B100110Mode,
  getSCode,
  KazeiKbn,
  MinuszaikocheckKbn,
  SakujoyoteiKbn,
  SetshohinKbn,
  ShohinshubetsuKbn,
  ShokuchiKbn,
  TankaKbn,
  UrikiriKbn,
  ZaikohikiateKbn,
  ZaikokanriKbn,
} from "messages/codes";
import { UseFormReturn } from "react-hook-form";

export type B100110CreateRequest = {
  shohinNm: string;
  shohinNmr: string;
  shokuchiKbn: string;
  torihikikaishiYmd: string;
  torihikishuryoYmd: string;
  kazeiKbn: string;
  tankaKbn: string;
  setshohinKbn: string;
  shohinshubetsuKbn: string;
  urikiriKbn: string;
  zaikokanriKbn: string;
  zaikohikiateKbn: string;
  minuszaikocheckKbn: string;
  sakujoyoteiKbn: string;
} & Partial<{
  shohinKana: string;
  janCd: string;
  sakaCd: string;
  vol: string;
  shireCd: string;
  itfCd: string;
  whtankaCd: string;
  whgentankaCd: string;
  zairyoshohinCd: string;
  tashisun: string;
  loss2: string;
  sunpo: string;
  sotosunW: string;
  sotosunH: string;
  uchisunW: string;
  uchisunH: string;
  kakoshubetsuCd: string;
  shiyo1: string;
  shiyo2: string;
  shiyo3: string;
  shobunCd1: string;
  shobunCd2: string;
  shobunCd3: string;
  shobunCd4: string;
  shobunCd5: string;
  shodaibun: string;
  shochubun: string;
  shoshobun: string;
  chohyoBunruiCd1: string;
  chohyoBunruiCd2: string;
  chohyoBunruiCd3: string;
  chohyoBunruiCd4: string;
  chohyoBunruiCd5: string;
  chohyoBunruiCd6: string;
  chohyoBunruiCd7: string;
  chohyoBunruiCd8: string;
  chohyoBunruiCd9: string;
  chohyoBunruiCd10: string;
  chohyoBunruiCd11: string;
  chohyoBunruiCd12: string;
  chohyoBunruiCd13: string;
  chohyoBunruiCd14: string;
  chohyoBunruiCd15: string;
}>;

export type B100110CreateResponse = {
  shohinCd: string;
};

//新規登録処理
export const B100110Create = (methods: UseFormReturn) => {
  const fields = methods.getValues();

  const data: B100110CreateRequest = {
    shohinNm: fields.shohinNm,
    shohinKana: fields.shohinKana,
    shohinNmr: fields.shohinNmr,
    shokuchiKbn: fields.shokuchiKbn.value,
    janCd: fields.janCd,
    sakaCd: fields.sakaCd,
    vol: fields.vol,
    shireCd: fields.shireCd,
    torihikikaishiYmd: fields.torihikikaishiYmd,
    torihikishuryoYmd: fields.torihikishuryoYmd,
    itfCd: fields.itfCd,
    kazeiKbn: fields.kazeiKbn.value,
    tankaKbn: fields.tankaKbn.value,
    whtankaCd: fields.whtankaCd,
    whgentankaCd: fields.whgentankaCd,
    setshohinKbn: fields.setshohinKbn.value,
    shohinshubetsuKbn: fields.shohinshubetsuKbn.value,
    urikiriKbn: fields.urikiriKbn.value,
    zairyoshohinCd: fields.zairyoshohinCd,
    tashisun: fields.tashisun,
    loss2: fields.loss2,
    sunpo: fields.sunpo,
    sotosunW: fields.sotosunW,
    sotosunH: fields.sotosunH,
    uchisunW: fields.uchisunW,
    uchisunH: fields.uchisunH,
    kakoshubetsuCd: fields.kakoshubetsuCd,
    shiyo1: fields.shiyo1,
    shiyo2: fields.shiyo2,
    shiyo3: fields.shiyo3,
    zaikokanriKbn: fields.zaikokanriKbn.value,
    zaikohikiateKbn: fields.zaikohikiateKbn.value,
    minuszaikocheckKbn: fields.minuszaikocheckKbn.value,
    sakujoyoteiKbn: fields.sakujoyoteiKbn.value,
    shobunCd1: fields.shobunCd1,
    shobunCd2: fields.shobunCd2,
    shobunCd3: fields.shobunCd3,
    shobunCd4: fields.shobunCd4,
    shobunCd5: fields.shobunCd5,
    shodaibun: fields.shodaibun,
    shochubun: fields.shochubun,
    shoshobun: fields.shoshobun,
    chohyoBunruiCd1: fields.chohyoBunruiCd1,
    chohyoBunruiCd2: fields.chohyoBunruiCd2,
    chohyoBunruiCd3: fields.chohyoBunruiCd3,
    chohyoBunruiCd4: fields.chohyoBunruiCd4,
    chohyoBunruiCd5: fields.chohyoBunruiCd5,
    chohyoBunruiCd6: fields.chohyoBunruiCd6,
    chohyoBunruiCd7: fields.chohyoBunruiCd7,
    chohyoBunruiCd8: fields.chohyoBunruiCd8,
    chohyoBunruiCd9: fields.chohyoBunruiCd9,
    chohyoBunruiCd10: fields.chohyoBunruiCd10,
    chohyoBunruiCd11: fields.chohyoBunruiCd11,
    chohyoBunruiCd12: fields.chohyoBunruiCd12,
    chohyoBunruiCd13: fields.chohyoBunruiCd13,
    chohyoBunruiCd14: fields.chohyoBunruiCd14,
    chohyoBunruiCd15: fields.chohyoBunruiCd15,
  };

  return RestClient.post<B100110CreateResponse>("b100110/create", data);
};

export type B100110UpdateRequest = {
  shohinCd: string;
  shohinNm: string;
  shohinNmr: string;
  shokuchiKbn: string;
  torihikikaishiYmd: string;
  torihikishuryoYmd: string;
  kazeiKbn: string;
  tankaKbn: string;
  setshohinKbn: string;
  shohinshubetsuKbn: string;
  urikiriKbn: string;
  zaikokanriKbn: string;
  zaikohikiateKbn: string;
  minuszaikocheckKbn: string;
  sakujoyoteiKbn: string;
} & Partial<{
  shohinKana: string;
  janCd: string;
  sakaCd: string;
  vol: string;
  shireCd: string;
  itfCd: string;
  whtankaCd: string;
  whgentankaCd: string;
  zairyoshohinCd: string;
  tashisun: string;
  loss2: string;
  sunpo: string;
  sotosunW: string;
  sotosunH: string;
  uchisunW: string;
  uchisunH: string;
  kakoshubetsuCd: string;
  shiyo1: string;
  shiyo2: string;
  shiyo3: string;
  shobunCd1: string;
  shobunCd2: string;
  shobunCd3: string;
  shobunCd4: string;
  shobunCd5: string;
  shodaibun: string;
  shochubun: string;
  shoshobun: string;
  chohyoBunruiCd1: string;
  chohyoBunruiCd2: string;
  chohyoBunruiCd3: string;
  chohyoBunruiCd4: string;
  chohyoBunruiCd5: string;
  chohyoBunruiCd6: string;
  chohyoBunruiCd7: string;
  chohyoBunruiCd8: string;
  chohyoBunruiCd9: string;
  chohyoBunruiCd10: string;
  chohyoBunruiCd11: string;
  chohyoBunruiCd12: string;
  chohyoBunruiCd13: string;
  chohyoBunruiCd14: string;
  chohyoBunruiCd15: string;
  version: string;
}>;

export const B100110Update = (methods: UseFormReturn) => {
  const fields = methods.getValues();

  const data: B100110UpdateRequest = {
    shohinCd: fields.shohinCd,
    shohinNm: fields.shohinNm,
    shohinKana: fields.shohinKana,
    shohinNmr: fields.shohinNmr,
    shokuchiKbn: fields.shokuchiKbn.value,
    janCd: fields.janCd,
    sakaCd: fields.sakaCd,
    vol: fields.vol,
    shireCd: fields.shireCd,
    torihikikaishiYmd: fields.torihikikaishiYmd,
    torihikishuryoYmd: fields.torihikishuryoYmd,
    itfCd: fields.itfCd,
    kazeiKbn: fields.kazeiKbn.value,
    tankaKbn: fields.tankaKbn.value,
    whtankaCd: fields.whtankaCd,
    whgentankaCd: fields.whgentankaCd,
    setshohinKbn: fields.setshohinKbn.value,
    shohinshubetsuKbn: fields.shohinshubetsuKbn.value,
    urikiriKbn: fields.urikiriKbn.value,
    zairyoshohinCd: fields.zairyoshohinCd,
    tashisun: fields.tashisun,
    loss2: fields.loss2,
    sunpo: fields.sunpo,
    sotosunW: fields.sotosunW,
    sotosunH: fields.sotosunH,
    uchisunW: fields.uchisunW,
    uchisunH: fields.uchisunH,
    kakoshubetsuCd: fields.kakoshubetsuCd,
    shiyo1: fields.shiyo1,
    shiyo2: fields.shiyo2,
    shiyo3: fields.shiyo3,
    zaikokanriKbn: fields.zaikokanriKbn.value,
    zaikohikiateKbn: fields.zaikohikiateKbn.value,
    minuszaikocheckKbn: fields.minuszaikocheckKbn.value,
    sakujoyoteiKbn: fields.sakujoyoteiKbn.value,
    shobunCd1: fields.shobunCd1,
    shobunCd2: fields.shobunCd2,
    shobunCd3: fields.shobunCd3,
    shobunCd4: fields.shobunCd4,
    shobunCd5: fields.shobunCd5,
    shodaibun: fields.shodaibun,
    shochubun: fields.shochubun,
    shoshobun: fields.shoshobun,
    chohyoBunruiCd1: fields.chohyoBunruiCd1,
    chohyoBunruiCd2: fields.chohyoBunruiCd2,
    chohyoBunruiCd3: fields.chohyoBunruiCd3,
    chohyoBunruiCd4: fields.chohyoBunruiCd4,
    chohyoBunruiCd5: fields.chohyoBunruiCd5,
    chohyoBunruiCd6: fields.chohyoBunruiCd6,
    chohyoBunruiCd7: fields.chohyoBunruiCd7,
    chohyoBunruiCd8: fields.chohyoBunruiCd8,
    chohyoBunruiCd9: fields.chohyoBunruiCd9,
    chohyoBunruiCd10: fields.chohyoBunruiCd10,
    chohyoBunruiCd11: fields.chohyoBunruiCd11,
    chohyoBunruiCd12: fields.chohyoBunruiCd12,
    chohyoBunruiCd13: fields.chohyoBunruiCd13,
    chohyoBunruiCd14: fields.chohyoBunruiCd14,
    chohyoBunruiCd15: fields.chohyoBunruiCd15,
    version: fields.version,
  };

  return RestClient.put<B100110CreateResponse>("b100110/update", data);
};

export type B100110GetRequest = {
  shohinCd: string;
} & Partial<{}>;

export const B100110Get = (props: B100110GetRequest) => {
  return RestClient.get("b100110/get", {
    params: props,
  });
};

// 商品情報表示処理
export const B100110Shohin = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  // 変更されていない場合は切替しない
  if (!methods.getFieldState("shohinCd").isDirty) {
    return;
  }

  const data = methods.getValues();
  if (data.shohinCd === "") {
    methods.reset();
    methods.reset({
      ...methods.getValues(),
      shohinCd: "",
      sanshoShohinCd: "",
    });
    methods.setValue("modeKbn", getSCode(B100110Mode, data.modeKbn?.value));
    return;
  }
  await B100110Get({
    shohinCd: data.shohinCd,
  })
    .then((response) => {
      methods.setValue("shohinNm", response.data.shohinNm ?? "");
      methods.setValue("shohinKana", response.data.shohinKana ?? "");
      methods.setValue("shohinNmr", response.data.shohinNmr ?? "");
      methods.setValue(
        "shokuchiKbn",
        getSCode(ShokuchiKbn, response.data.shokuchiKbn) ?? null
      );
      methods.setValue("janCd", response.data.janCd ?? "");
      methods.setValue("sakaCd", response.data.sakaCd ?? "");
      methods.setValue("vol", response.data.vol ?? "");
      methods.setValue("shireCd", response.data.shireCd ?? "");
      methods.setValue(
        "torihikikaishiYmd",
        response.data.torihikikaishiYmd ?? null
      );
      methods.setValue(
        "torihikishuryoYmd",
        response.data.torihikishuryoYmd ?? null
      );
      methods.setValue("itfCd", response.data.itfCd ?? "");
      methods.setValue(
        "kazeiKbn",
        getSCode(KazeiKbn, response.data.kazeiKbn) ?? null
      );
      methods.setValue(
        "tankaKbn",
        getSCode(TankaKbn, response.data.tankaKbn) ?? null
      );
      methods.setValue("whtankaCd", response.data.whtankaCd ?? "");
      methods.setValue("whgentankaCd", response.data.whgentankaCd ?? "");
      methods.setValue(
        "setshohinKbn",
        getSCode(SetshohinKbn, response.data.setshohinKbn) ?? null
      );
      methods.setValue(
        "shohinshubetsuKbn",
        getSCode(ShohinshubetsuKbn, response.data.shohinshubetsuKbn) ?? null
      );
      methods.setValue(
        "urikiriKbn",
        getSCode(UrikiriKbn, response.data.urikiriKbn) ?? null
      );
      methods.setValue("zairyoshohinCd", response.data.zairyoshohinCd ?? "");
      methods.setValue("tashisun", response.data.tashisun ?? "");
      methods.setValue("loss2", response.data.loss2 ?? "");
      methods.setValue("sunpo", response.data.sunpo ?? "");
      methods.setValue("sotosunW", response.data.sotosunW ?? "");
      methods.setValue("sotosunH", response.data.sotosunH ?? "");
      methods.setValue("uchisunW", response.data.uchisunW ?? "");
      methods.setValue("uchisunH", response.data.uchisunH ?? "");
      methods.setValue("kakoshubetsuCd", response.data.kakoshubetsuCd ?? "");
      methods.setValue("shiyo1", response.data.shiyo1 ?? "");
      methods.setValue("shiyo2", response.data.shiyo2 ?? "");
      methods.setValue("shiyo3", response.data.shiyo3 ?? "");
      methods.setValue(
        "zaikokanriKbn",
        getSCode(ZaikokanriKbn, response.data.zaikokanriKbn) ?? null
      );
      methods.setValue(
        "zaikohikiateKbn",
        getSCode(ZaikohikiateKbn, response.data.zaikohikiateKbn) ?? null
      );
      methods.setValue(
        "minuszaikocheckKbn",
        getSCode(MinuszaikocheckKbn, response.data.minuszaikocheckKbn) ?? null
      );
      methods.setValue(
        "sakujoyoteiKbn",
        getSCode(SakujoyoteiKbn, response.data.sakujoyoteiKbn) ?? null
      );

      methods.setValue("shobunCd1", response.data.shobunCd1 ?? "");
      methods.setValue("shobunCd2", response.data.shobunCd2 ?? "");
      methods.setValue("shobunCd3", response.data.shobunCd3 ?? "");
      methods.setValue("shobunCd4", response.data.shobunCd4 ?? "");
      methods.setValue("shobunCd5", response.data.shobunCd5 ?? "");
      methods.setValue("shodaibun", response.data.shodaibun ?? "");
      methods.setValue("shochubun", response.data.shochubun ?? "");
      methods.setValue("shoshobun", response.data.shoshobun ?? "");
      methods.setValue("chohyoBunruiCd1", response.data.chohyoBunruiCd1 ?? "");
      methods.setValue("chohyoBunruiCd2", response.data.chohyoBunruiCd2 ?? "");
      methods.setValue("chohyoBunruiCd3", response.data.chohyoBunruiCd3 ?? "");
      methods.setValue("chohyoBunruiCd4", response.data.chohyoBunruiCd4 ?? "");
      methods.setValue("chohyoBunruiCd5", response.data.chohyoBunruiCd5 ?? "");
      methods.setValue("chohyoBunruiCd6", response.data.chohyoBunruiCd6 ?? "");
      methods.setValue("chohyoBunruiCd7", response.data.chohyoBunruiCd7 ?? "");
      methods.setValue("chohyoBunruiCd8", response.data.chohyoBunruiCd8 ?? "");
      methods.setValue("chohyoBunruiCd9", response.data.chohyoBunruiCd9 ?? "");
      methods.setValue(
        "chohyoBunruiCd10",
        response.data.chohyoBunruiCd10 ?? ""
      );
      methods.setValue(
        "chohyoBunruiCd11",
        response.data.chohyoBunruiCd11 ?? ""
      );
      methods.setValue(
        "chohyoBunruiCd12",
        response.data.chohyoBunruiCd12 ?? ""
      );
      methods.setValue(
        "chohyoBunruiCd13",
        response.data.chohyoBunruiCd13 ?? ""
      );
      methods.setValue(
        "chohyoBunruiCd14",
        response.data.chohyoBunruiCd14 ?? ""
      );
      methods.setValue(
        "chohyoBunruiCd15",
        response.data.chohyoBunruiCd15 ?? ""
      );
      methods.setValue("version", response.data.version ?? "");

      // 値を保持
      methods.unregister("shohinCd", { keepValue: true });

      // コードに紐づく名称の設定
      B100110HandleSetNm(methods, navigate, setMsg);
    })
    .catch((reason) => {
      methods.reset();
      methods.reset({
        ...methods.getValues(),
        sanshoShohinCd: "",
      });
      methods.setValue("shohinCd", data.shohinCd);
      methods.setValue("modeKbn", getSCode(B100110Mode, data.modeKbn?.value));
      catchRestError(reason, navigate, setMsg);
    });
};

// 参照商品情報表示処理
export const B100110SanshoShohin = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  // 変更されていない場合は切替しない
  if (!methods.getFieldState("sanshoShohinCd").isDirty) {
    return;
  }

  const data = methods.getValues();
  if (data.sanshoShohinCd === "") {
    methods.reset();
    methods.reset({
      ...methods.getValues(),
      shohinCd: "",
      sanshoShohinCd: "",
    });
    methods.setValue("modeKbn", getSCode(B100110Mode, data.modeKbn?.value));
    return;
  }
  await B100110Get({
    shohinCd: data.sanshoShohinCd,
  })
    .then((response) => {
      methods.setValue("shohinNm", response.data.shohinNm ?? "");
      methods.setValue("shohinKana", response.data.shohinKana ?? "");
      methods.setValue("shohinNmr", response.data.shohinNmr ?? "");
      methods.setValue(
        "shokuchiKbn",
        getSCode(ShokuchiKbn, response.data.shokuchiKbn) ?? null
      );
      methods.setValue("sakaCd", response.data.sakaCd ?? "");
      methods.setValue("vol", response.data.vol ?? "");
      methods.setValue("shireCd", response.data.shireCd ?? "");
      methods.setValue(
        "torihikikaishiYmd",
        response.data.torihikikaishiYmd ?? null
      );
      methods.setValue(
        "torihikishuryoYmd",
        response.data.torihikishuryoYmd ?? null
      );
      methods.setValue("itfCd", response.data.itfCd ?? "");
      methods.setValue(
        "kazeiKbn",
        getSCode(KazeiKbn, response.data.kazeiKbn) ?? null
      );
      methods.setValue(
        "tankaKbn",
        getSCode(TankaKbn, response.data.tankaKbn) ?? null
      );
      methods.setValue("whtankaCd", response.data.whtankaCd ?? "");
      methods.setValue("whgentankaCd", response.data.whgentankaCd ?? "");
      methods.setValue(
        "setshohinKbn",
        getSCode(SetshohinKbn, response.data.setshohinKbn) ?? null
      );
      methods.setValue(
        "shohinshubetsuKbn",
        getSCode(ShohinshubetsuKbn, response.data.shohinshubetsuKbn) ?? null
      );
      methods.setValue(
        "urikiriKbn",
        getSCode(UrikiriKbn, response.data.urikiriKbn) ?? null
      );
      methods.setValue("zairyoshohinCd", response.data.zairyoshohinCd ?? "");
      methods.setValue("tashisun", response.data.tashisun ?? "");
      methods.setValue("loss2", response.data.loss2 ?? "");
      methods.setValue("sunpo", response.data.sunpo ?? "");
      methods.setValue("sotosunW", response.data.sotosunW ?? "");
      methods.setValue("sotosunH", response.data.sotosunH ?? "");
      methods.setValue("uchisunW", response.data.uchisunW ?? "");
      methods.setValue("uchisunH", response.data.uchisunH ?? "");
      methods.setValue("kakoshubetsuCd", response.data.kakoshubetsuCd ?? "");
      methods.setValue("shiyo1", response.data.shiyo1 ?? "");
      methods.setValue("shiyo2", response.data.shiyo2 ?? "");
      methods.setValue("shiyo3", response.data.shiyo3 ?? "");
      methods.setValue(
        "zaikokanriKbn",
        getSCode(ZaikokanriKbn, response.data.zaikokanriKbn) ?? null
      );
      methods.setValue(
        "zaikohikiateKbn",
        getSCode(ZaikohikiateKbn, response.data.zaikohikiateKbn) ?? null
      );
      methods.setValue(
        "minuszaikocheckKbn",
        getSCode(MinuszaikocheckKbn, response.data.minuszaikocheckKbn) ?? null
      );
      methods.setValue(
        "sakujoyoteiKbn",
        getSCode(SakujoyoteiKbn, response.data.sakujoyoteiKbn) ?? null
      );

      methods.setValue("shobunCd1", response.data.shobunCd1 ?? "");
      methods.setValue("shobunCd2", response.data.shobunCd2 ?? "");
      methods.setValue("shobunCd3", response.data.shobunCd3 ?? "");
      methods.setValue("shobunCd4", response.data.shobunCd4 ?? "");
      methods.setValue("shobunCd5", response.data.shobunCd5 ?? "");
      methods.setValue("shodaibun", response.data.shodaibun ?? "");
      methods.setValue("shochubun", response.data.shochubun ?? "");
      methods.setValue("shoshobun", response.data.shoshobun ?? "");
      methods.setValue("chohyoBunruiCd1", response.data.chohyoBunruiCd1 ?? "");
      methods.setValue("chohyoBunruiCd2", response.data.chohyoBunruiCd2 ?? "");
      methods.setValue("chohyoBunruiCd3", response.data.chohyoBunruiCd3 ?? "");
      methods.setValue("chohyoBunruiCd4", response.data.chohyoBunruiCd4 ?? "");
      methods.setValue("chohyoBunruiCd5", response.data.chohyoBunruiCd5 ?? "");
      methods.setValue("chohyoBunruiCd6", response.data.chohyoBunruiCd6 ?? "");
      methods.setValue("chohyoBunruiCd7", response.data.chohyoBunruiCd7 ?? "");
      methods.setValue("chohyoBunruiCd8", response.data.chohyoBunruiCd8 ?? "");
      methods.setValue("chohyoBunruiCd9", response.data.chohyoBunruiCd9 ?? "");
      methods.setValue(
        "chohyoBunruiCd10",
        response.data.chohyoBunruiCd10 ?? ""
      );
      methods.setValue(
        "chohyoBunruiCd11",
        response.data.chohyoBunruiCd11 ?? ""
      );
      methods.setValue(
        "chohyoBunruiCd12",
        response.data.chohyoBunruiCd12 ?? ""
      );
      methods.setValue(
        "chohyoBunruiCd13",
        response.data.chohyoBunruiCd13 ?? ""
      );
      methods.setValue(
        "chohyoBunruiCd14",
        response.data.chohyoBunruiCd14 ?? ""
      );
      methods.setValue(
        "chohyoBunruiCd15",
        response.data.chohyoBunruiCd15 ?? ""
      );

      // 値を保持
      methods.unregister("sanshoShohinCd", { keepValue: true });

      // コードに紐づく名称、端数位置の設定
      B100110HandleSetNm(methods, navigate, setMsg);
    })
    .catch((reason) => {
      methods.reset();
      methods.reset({
        ...methods.getValues(),
        shohinCd: "",
      });
      methods.setValue("sanshoShohinCd", data.sanshoShohinCd);
      methods.setValue("modeKbn", getSCode(B100110Mode, data.modeKbn?.value));
      catchRestError(reason, navigate, setMsg);
    });
};

// コードに紐づく名称の設定
export const B100110HandleSetNm = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  // 作家名表示
  B000111SakaNm(methods, navigate, setMsg);

  // 標準仕入先名表示
  B000170ShireNmr(methods, navigate, setMsg);

  // WH 単価名表示
  B000111WhtankaNm(methods, navigate, setMsg);

  // WH 原単価名表示
  B000111WhgentankaNm(methods, navigate, setMsg);

  // 材料品名表示
  B000200ZairyoshohinNm(methods, navigate, setMsg);

  // 加工種別名表示
  B000111KakoshubetsuNm(methods, navigate, setMsg);

  // 商品分類 1 名表示
  B000111ShobumNm1(methods, navigate, setMsg);

  // 商品分類 2 名表示
  B000111ShobumNm2(methods, navigate, setMsg);

  // 商品分類 3 名表示
  B000111ShobumNm3(methods, navigate, setMsg);

  //  商品分類 4 名表示
  B000111ShobumNm4(methods, navigate, setMsg);

  // 商品分類 5 名表示
  B000111ShobumNm5(methods, navigate, setMsg);

  // 商品小分類名表示
  B000202ShoshobunruiNm(methods, navigate, setMsg);

  // 商品中分類名表示
  B000202ShochubunruiNm(methods, navigate, setMsg);

  // 商品大分類名表示
  B000202ShodaibunruiNm(methods, navigate, setMsg);

  // 帳票分類名 1 表示
  B000111ChohyoBunruiNm1(methods, navigate, setMsg);

  // 帳票分類名 2 表示
  B000111ChohyoBunruiNm2(methods, navigate, setMsg);

  // 帳票分類名 3 表示
  B000111ChohyoBunruiNm3(methods, navigate, setMsg);

  // 帳票分類名 4 表示
  B000111ChohyoBunruiNm4(methods, navigate, setMsg);

  // 帳票分類名 5 表示
  B000111ChohyoBunruiNm5(methods, navigate, setMsg);

  // 帳票分類名 6 表示
  B000111ChohyoBunruiNm6(methods, navigate, setMsg);

  // 帳票分類名 7 表示
  B000111ChohyoBunruiNm7(methods, navigate, setMsg);

  // 帳票分類名 8 表示
  B000111ChohyoBunruiNm8(methods, navigate, setMsg);

  // 帳票分類名 9 表示
  B000111ChohyoBunruiNm9(methods, navigate, setMsg);

  // 帳票分類名 10 表示
  B000111ChohyoBunruiNm10(methods, navigate, setMsg);

  // 帳票分類名 11 表示
  B000111ChohyoBunruiNm11(methods, navigate, setMsg);

  // 帳票分類名 12 表示
  B000111ChohyoBunruiNm12(methods, navigate, setMsg);

  // 帳票分類名 13 表示
  B000111ChohyoBunruiNm13(methods, navigate, setMsg);

  // 帳票分類名 14 表示
  B000111ChohyoBunruiNm14(methods, navigate, setMsg);

  // 帳票分類名 15 表示
  B000111ChohyoBunruiNm15(methods, navigate, setMsg);
};

// 商品コードで商品名を取得するメソッド(shohinNmFromにセット)
export const B100113ShohinNmFrom = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shohinCdFrom === "") {
    methods.setValue("shohinNmFrom", "");
    return;
  }
  await B100110Get({ shohinCd: data.shohinCdFrom })
    .then((response) => {
      methods.setValue("shohinNmFrom", response.data.shohinNm ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shohinNmFrom", "");
    });
};

// 商品コードで商品名を取得するメソッド(shohinNmToにセット)
export const B100113ShohinNmTo = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.shohinCdTo === "") {
    methods.setValue("shohinNmTo", "");
    return;
  }
  await B100110Get({ shohinCd: data.shohinCdTo })
    .then((response) => {
      methods.setValue("shohinNmTo", response.data.shohinNm ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("shohinNmTo", "");
    });
};

export type B100110GetByJancdRequest = {
  janCd: string;
};

export const B100110GetByJancd = (props: B100110GetByJancdRequest) => {
  return RestClient.get("b100110/get/jancd", {
    params: props,
  });
};

// JANコードで商品名を取得するメソッド(janShohinNmFromにセット)
export const B100113JanShohinNmFrom = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.janCdFrom === "") {
    methods.setValue("janShohinNmFrom", "");
    return;
  }
  await B100110GetByJancd({ janCd: data.janCdFrom })
    .then((response) => {
      methods.setValue("janShohinNmFrom", response.data.shohinNm ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("janShohinNmFrom", "");
    });
};

// JANコードで商品名を取得するメソッド(janShohinNmToにセット)
export const B100113JanShohinNmTo = async (
  methods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  if (data.janCdTo === "") {
    methods.setValue("janShohinNmTo", "");
    return;
  }
  await B100110GetByJancd({ janCd: data.janCdTo })
    .then((response) => {
      methods.setValue("janShohinNmTo", response.data.shohinNm ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      methods.setValue("janShohinNmTo", "");
    });
};
